type RightSideInfoProps = {
  readonly title: string
  readonly description: string
}

export function RightSideInfo({ title, description }: RightSideInfoProps) {
  return (
    <>
      <span className="block text-base font-bold min-[1126px]:text-2xl">
        {title}
      </span>
      <span className="block text-sm min-[1126px]:text-base">
        {description}
      </span>
    </>
  )
}
